import styled from 'styled-components';

export const FormContainer = styled.main`
  display: grid;
  grid-template-columns: auto 324px;
  gap: 24px;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const Section = styled.section`
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  & > header {
    line-height: 20px;
    font-size: 17px;
    font-weight: 700;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 13px;
  text-align: center;
  margin: 4px 0 0 0;
`;
